module.exports = __webpack_public_path__ + "img/1f414.aae4dc3.svg";